import { OptionsProps } from '../../../typings/general';
import {
  FormAttributeModel,
  FormValidationErrorAttributeModel,
  CurrentData,
  Status,
  Vehicle,
} from '../../typings/incentive-store';
import IncentiveConstants from './incentive-constants';

/**
 * Declaration of all the possible actions that InsentiveStore is going to handle
 * @param dispatch function that call reducer
 */
const getIncentiveActions = (dispatch: any) => ({
  [IncentiveConstants.SetInitialData]() {
    return dispatch(IncentiveConstants.SetInitialData);
  },
  [IncentiveConstants.UpdateStoreByFormInput](form: FormAttributeModel) {
    return dispatch(IncentiveConstants.UpdateStoreByFormInput, {
      form,
    });
  },
  [IncentiveConstants.ValidateForm](
    status: Status,
    formValidationError: FormValidationErrorAttributeModel,
  ) {
    return dispatch(
      IncentiveConstants.ValidateForm,
      status,
      formValidationError,
    );
  },
  [IncentiveConstants.SetModelYears](modelYears: OptionsProps[]) {
    return dispatch(IncentiveConstants.SetModelYears, modelYears);
  },
  [IncentiveConstants.SetModelCardData](
    currentData: CurrentData
  ) {
    return dispatch(IncentiveConstants.SetModelCardData, { currentData });
  },
  [IncentiveConstants.SetVehicleData](
    vehicle: Vehicle
  ) {
    return dispatch(IncentiveConstants.SetVehicleData, { vehicle })
  }
});

export default getIncentiveActions;
